import { useNavigate } from '@tanstack/react-router';
import { Button } from '@ygoargentina/ui/components/custom/button';
import { cn } from '@ygoargentina/ui/lib/utils';
import { AlertTriangle } from 'lucide-react';

interface GeneralErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  minimal?: boolean;
}

export default function GeneralError({
  className,
  minimal = false,
}: GeneralErrorProps) {
  const navigate = useNavigate();

  return (
    <div className={cn('h-svh w-full', className)}>
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        {!minimal && (
          <>
            <AlertTriangle className="h-20 w-20 text-destructive mb-2" />
            <h1 className="text-[7rem] leading-tight font-bold">500</h1>
          </>
        )}
        <span className="font-medium text-lg">
          Ups, algo salio mal
        </span>
        <p className="text-muted-foreground text-center">
          Lo sentimos, ocurrio un error inesperado. <br />
          Por favor, intenta de nuevo en unos minutos.
        </p>
        {!minimal && (
          <div className="mt-6 flex gap-4">
            <Button variant="outline" onClick={() => window.history.back()}>
              Volver atras
            </Button>
            <Button onClick={() => navigate({ to: '/' })}>Ir al inicio</Button>
          </div>
        )}
      </div>
    </div>
  );
}
